const config = require("config");

(function () {
  "use strict";

  angular
    .module("alk.forms")
    .directive("partnerAccountSelect", partnerAccountSelect);

  partnerAccountSelect.$inject = ["UserProvider"];

  function partnerAccountSelect(UserProvider) {

    function isRole(role) {
      var roles = UserProvider.getUser().roles;
      roles = _.map(roles, function (role) {
        return role.toLowerCase();
      });
      roles = _.uniq(roles);
      return roles.indexOf(role) !== -1;
    }

    function isSupportRole() {
      return isRole("support");
    }

    function isALKSupportRole() {
      return isRole("alk support");
    }

    var partnerAccountController = ["$http", "$window", "$scope", "$state", function ($http, $window, $scope, $state) {

      var vm = this;
      vm.partnerAccountChange = partnerAccountChange;

      init();

      function init() {
        let url = "";
        if (isALKSupportRole()) {
          url = config.ssoUrl + "v1/accounts/application?applicationName=" + PARTNER_APPLICATION_NAME;
        } else if (isSupportRole()) {
          url = config.fleetPortalUrl + "v1/account/partneraccounts?applicationName=" + PARTNER_APPLICATION_NAME;
        } else {
          return;
        }

        var request = {
          method: "GET",
          url: url,
          headers: {
            Authorization: "Bearer " + UserProvider.getUser().authToken,
            "ALK-Language": undefined
          }
        };

        $http(request).then(function (response) {
          vm.partnerAccounts =
            _.chain(response.data)
            .map((acct) => {
              // accounts that come from SSO have different attributes
              // than the accounts that come from fleetportal's partner account
              // api.
              if (acct.accountId === undefined)
                acct.accountId = acct.id;
              if (acct.accountName === undefined)
                acct.accountName = acct.name;
              return acct;
            })
            .sortBy("accountName")
            .value();
          var user = UserProvider.getUser();
          var accountId = user.accountId;
          if (user.supportAccount) {
            accountId = user.supportAccount.accountId;
          }

          if (accountId) {
            vm.selectedPartnerAccount = _.find(vm.partnerAccounts, {
              "accountId": Number(accountId)
            });
          }
        });
      }

      function partnerAccountChange() {
        var request = {
          method: "POST",
          url: config.daUrl + `owner/${vm.selectedPartnerAccount.accountId}?application=` + PARTNER_APPLICATION_NAME
        };

        $http(request)
          .then((resp) => {
            var currentUser = UserProvider.getUser();

            //  if we switch to the account we originally logged in as, just
            //  clear out any support account information.
            if (currentUser.accountId === vm.selectedPartnerAccount.accountId) {
              delete currentUser.supportOwnerId;
              delete currentUser.supportAccount;
            } else {
              currentUser.supportOwnerId = resp.data;
              currentUser.supportAccount = vm.selectedPartnerAccount;
            }
            $state.reload();
          });
      }
    }];

    var directive = {
      template: require("./partnerAccountSelect.html"),
      restrict: "A",
      scope: {
        //Should be the product name stored in the database.
        //i.e. "CloudXChange", "CoPilot FleetView"
        partnerAccountSelect: "@"
      },
      controller: partnerAccountController,
      controllerAs: "vm",
      link: function (scope, element) {
        //Don't show this directive if not a support role. We must delete the whole element because the navbar will display a
        //divider line to the right otherwise.
        if (!isSupportRole() && !isALKSupportRole()) {
          element.remove();
        }
      }
    };

    return directive;
  }

})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-forms/partner-account-select/partnerAccountSelect.directive.js